import { put, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import {
	handleNotificationAlertCatch,
	handleNotificationAlertTrySelect,
} from "../../../common/method/handleNotificationAlert";

export const actionTypes = {
	selectPaymentRequestsRayanHistory:
		"selectPaymentRequestsRayanHistory [Action]",
	selectPaymentRequestsRayanHistoryLoading:
		"selectPaymentRequestsRayanHistoryLoading [Action]",
	selectPaymentRequestsRayanHistoryAsync:
		"selectPaymentRequestsRayanHistoryAsync [Action]",
};
const inistiaState = {
	data: [],
	loading: false,
	total: 0,
};

export const selectPaymentRequestsRayanHistoryReducer = (
	state = inistiaState,
	{ type, payload },
) => {
	switch (type) {
		case actionTypes.selectPaymentRequestsRayanHistory:
			return {
				...state,
				data: payload?.results,
				total: payload?.total,
			};
		case actionTypes.selectPaymentRequestsRayanHistoryLoading:
			return {
				...state,
				loading: payload,
			};
		default:
			return state;
	}
};

function* handleWorker({ payload }) {
	yield put({
		type: actionTypes.selectPaymentRequestsRayanHistoryLoading,
		payload: true,
	});

	let config = {
		url: "select_request",
	};

	let data = {
		table: "payment",
		method_type: "select_payment_requests_rayan_history",
		data: payload?.data ? payload.data : {},
	};

	try {
		let res = yield AxiosCustom(config, data);
		let isOk = handleNotificationAlertTrySelect(res);
		if (!isOk) {
			return;
		}

		yield put({
			type: actionTypes.selectPaymentRequestsRayanHistory,
			payload: res?.data?.response?.data,
		});
	} catch {
		handleNotificationAlertCatch();
	} finally {
		yield put({
			type: actionTypes.selectPaymentRequestsRayanHistoryLoading,
			payload: false,
		});
	}
}

export function* selectPaymentRequestsRayanHistory() {
	yield takeLatest(
		actionTypes.selectPaymentRequestsRayanHistoryAsync,
		handleWorker,
	);
}
